import post from '@/api/core/http/post'
import { buildApiUrl } from '@/api/core/url'
import { TypedMutationsOptions } from '@/api/core/mutation/options'
import { useMutation } from '@tanstack/react-query'
import { ApiError } from '@/api/core/errors'
import {
  MigrateListingsResponse,
  migrateListingsResponseSchema
} from './schema'

const path = `/user/listings/migrate`

export const migrateListings = async (): Promise<MigrateListingsResponse> =>
  post<MigrateListingsResponse>(
    buildApiUrl(path),
    {},
    migrateListingsResponseSchema
  )

export const useMigrateListingsMutation = (
  mutationOptions?: TypedMutationsOptions<MigrateListingsResponse>
) => {
  return useMutation<MigrateListingsResponse, ApiError>(
    migrateListings,
    mutationOptions
  )
}
